module.exports = __webpack_public_path__ + "assets/layers_black.66b7ef81.svg";